export default __webpack_public_path__ + "static/media/GUMBO NR 5.9c08a75d.mp3";